import React from 'react';

// Internal modules
import type { IconProps } from './types';

export const StepOneSpot = ({
  spotBgColor = '#FFF',
}: IconProps = {}): React.ReactElement => (
  <svg
    fill="none"
    height="32"
    viewBox="0 0 32 32"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" fill={spotBgColor} r="16" />
    <path
      d="M17.875 22V10.8906H17.0938L13.4219 12.4375V13.8281L16.2031 12.8438V22H17.875Z"
      fill={'#515354'}
    />
  </svg>
);
